import { Injectable } from '@angular/core'
import { MappedEntity } from '@app/core/model/definitions/mapped-entity.interface'
import { ScopeVersion } from '@app/core/model/scope-version'
import { AuthService } from '@app/core/service/auth.service'
import { SowRetainedHoursStats } from '@app/features/scope-overview/model/sow-retained-hours-stats.model'
import { TableColumnKey } from '@app/shared/components/ui-components/scope-ui-table/table-column-key.enum'
import { TableColumnPreferences } from '@app/shared/components/ui-components/scope-ui-table/table-column-preferences.type'
import { FolderOverviewService } from './folder-overview.service'

@Injectable({ providedIn: 'root' })
export class FolderOverviewMappingService {
  constructor(
    private authService: AuthService,
    private folderOverviewService: FolderOverviewService
  ) {}

  mapScopes(
    scopes: ScopeVersion[],
    preferences: TableColumnPreferences,
    retainedHoursStats: SowRetainedHoursStats
  ): MappedEntity<ScopeVersion>[] {
    return (scopes || []).map((data) =>
      Object.entries(preferences).reduce(
        (newObj, [key, config]) => {
          if (config.selected) {
            const scopeNumber = data?.identity?.localId
            const scopeString = scopeNumber ? `S-${scopeNumber}` : undefined

            if (config.key === TableColumnKey.SCOPE_NUMBER && scopeString) {
              newObj[config.key] = scopeString
              return newObj
            }
            if (config.key === TableColumnKey.RETAINED_HOURS_USED) {
              newObj[config.key] = this.folderOverviewService.getUsedRetainedHoursForScope(data, retainedHoursStats)
              return newObj
            }

            newObj[key] =
              (!config.requiredPrivilege ||
                data.hasPrivilege(config.requiredPrivilege, this.authService.loggedInUser!)) &&
              (!config.isVisible || config.isVisible(data))
                ? config.value
                  ? config.value(data)
                  : this.getValueByPath(data, config.field || '')
                : config.default
          }

          return newObj
        },
        { entity: data } as MappedEntity<ScopeVersion>
      )
    )
  }

  private getValueByPath(obj: any, path: string): any {
    const value = path.split('.').reduce((acc, part) => acc && acc[part], obj)
    return value != null ? value : '-'
  }
}
